import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /toolkit has no page of its own — older links and bookmarks point here
 * expecting the tools collection. Redirect to /explore, which lists them.
 */
export const Route = createFileRoute("/toolkit")({
  beforeLoad: () => {
    throw redirect({ to: "/explore" });
  },
  component: () => null,
});
